<template>
  <div>
    <el-row>
      <el-col :span="24">
        <el-card class="box-card">
          <div slot="header" class="flex justify-between">
            <span>优惠券池</span>
            <div class="float-right">
              <el-button type="primary" size="small" @click="_openParkingCouponShopPoolModal">
                <i class="el-icon-plus"></i>
                停车劵赠送
              </el-button>
              <el-button type="primary" size="small" @click="_openSendCouponShopPoolModal">
                <i class="el-icon-plus"></i>
                手工赠送
              </el-button>
              <el-button type="primary" size="small" @click="_openAddCouponShopPoolModal">
                <i class="el-icon-plus"></i>
                购买优惠劵
              </el-button>
            </div>
          </div>

          <el-table :data="couponShopPoolManageInfo.couponShopPools" style="width: 100%" border stripe>
            <el-table-column prop="spId" label="优惠券编号" align="center"></el-table-column>
            <el-table-column prop="couponName" label="优惠券名称" align="center"></el-table-column>
            <el-table-column prop="actualPrice" label="面值" align="center"></el-table-column>
            <el-table-column prop="stock" label="库存" align="center"></el-table-column>
            <el-table-column prop="validityDay" label="有效期" align="center"></el-table-column>
          </el-table>

          <el-pagination @current-change="handleCurrentChange" :current-page="couponShopPoolManageInfo.conditions.page"
            :page-size="couponShopPoolManageInfo.conditions.row" layout="total, prev, pager, next, jumper"
            :total="couponShopPoolManageInfo.total" class="pagination"></el-pagination>
        </el-card>
      </el-col>
    </el-row>

    <add-coupon-shop-pool ref="addCouponShopPool" @refresh="_listCouponShopPools()"></add-coupon-shop-pool>
    <choose-coupon-pool ref="chooseCouponPool" @refresh="_listCouponShopPools()"></choose-coupon-pool>
    <choose-coupon-pool-send ref="chooseCouponPoolSend" @refresh="_listCouponShopPools()"></choose-coupon-pool-send>
    <choose-coupon-pool-send-parking ref="chooseCouponPoolSendParking" @refresh="_listCouponShopPools()"></choose-coupon-pool-send-parking>
  </div>
</template>

<script>
import { listCouponShopPool } from '@/api/goods/couponShopPoolApi'
import AddCouponShopPool from '@/components/goods/addCouponShopPool'
import ChooseCouponPool from '@/components/goods/chooseCouponPool'
import ChooseCouponPoolSend from '@/components/goods/chooseCouponPoolSend'
import ChooseCouponPoolSendParking from '@/components/goods/chooseCouponPoolSendParking'
import { getShopId } from '@/api/shop/shopApi'

export default {
  name: 'CouponShopPoolManage',
  components: {
    AddCouponShopPool,
    ChooseCouponPool,
    ChooseCouponPoolSend,
    ChooseCouponPoolSendParking
  },
  data() {
    return {
      couponShopPoolManageInfo: {
        couponShopPools: [],
        total: 0,
        conditions: {
          page: 1,
          row: 10,
          couponName: '',
          shopId: '',
          caId: ''
        }
      }
    }
  },
  created() {
    this._listCouponShopPools()
  },
  methods: {
    async _listCouponShopPools() {
      this.couponShopPoolManageInfo.conditions.caId = getShopId()
      try {
        const res = await listCouponShopPool(this.couponShopPoolManageInfo.conditions)
        this.couponShopPoolManageInfo.couponShopPools = res.data
        this.couponShopPoolManageInfo.total = res.records
      } catch (error) {
        console.error(error)
      }
    },
    handleCurrentChange(val) {
      this.couponShopPoolManageInfo.conditions.page = val
      this._listCouponShopPools()
    },
    _openAddCouponShopPoolModal() {
      this.$refs.chooseCouponPool.open()
    },
    _openSendCouponShopPoolModal() {
      this.$refs.chooseCouponPoolSend.open()
    },
    _openParkingCouponShopPoolModal() {
      this.$refs.chooseCouponPoolSendParking.open()
    },
    _openEditCouponShopPoolModel(couponShopPool) {
      console.log(couponShopPool)
      this.$refs.editCouponShopPool.open(couponShopPool)
    },
    _openDeleteCouponShopPoolModel(couponShopPool) {
      console.log(couponShopPool)
      this.$refs.deleteCouponShopPool.open(couponShopPool)
    }
  }
}
</script>

<style scoped>
.float-right {
  float: right;
}

.pagination {
  margin-top: 15px;
  text-align: right;
}
</style>